import { inWindowsOS } from '../inWindowsOS';

import { FILE_TYPES } from '../constants';

/**
 * Returns a string appropriate for use in the `accept` property of an <input type="file">.
 * If there is no appropriate string, returns undefined so that the `accept` property remains
 * undefined rather than being set to an empty string;
 */
export const getFileInputAccept = (
    acceptedFileTypeKeys: FileTypeKey[] | undefined,
): string | undefined => {
    if (
        acceptedFileTypeKeys === undefined ||
        acceptedFileTypeKeys.length === 0 ||
        inWindowsOS // We can't rely on file.type in Windows; see ./hasAcceptedFileType for details
    ) {
        return undefined;
    }

    let acceptStrings = [] as string[];

    for (const acceptedFileTypeKey of acceptedFileTypeKeys) {
        const { mimeTypes } = FILE_TYPES[acceptedFileTypeKey];

        acceptStrings = acceptStrings.concat(mimeTypes);
    }

    const mimeTypeLists = acceptedFileTypeKeys.map(
        (acceptedFileTypeKey: FileTypeKey): string[] =>
            FILE_TYPES[acceptedFileTypeKey].mimeTypes,
    );

    return mimeTypeLists.flat().join(', ');
};
